module.exports = __webpack_public_path__ + "img/renault-new.f6edcb10.svg";